export default "__VITE_ASSET__GVwgqwMi__"